/* Theme-only correction for the inherited, expired preorder promise.
   Does not change preorder eligibility, payment behaviour or app configuration. */
(() => {
  const replacement = document.documentElement.dataset.bhPreorderMessage;
  if (!replacement) return;
  let scheduled = false;
  const update = () => {
    scheduled = false;
    document.querySelectorAll('[data-essential-preorder-element="message"]').forEach(message => {
      if (/guaranteed delivery by the end of September/i.test(message.textContent)) {
        message.textContent = replacement;
      }
    });
  };
  new MutationObserver(() => {
    if (!scheduled) { scheduled = true; requestAnimationFrame(update); }
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
  update();
})();
